// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"3d81eec4","586":"296a581b"}[chunkId] + ".chunk.css";
};